import { render } from "./InterimDemand.component.vue?vue&type=template&id=23fc1101&scoped=true"
import script from "./InterimDemand.component.vue?vue&type=script&lang=js"
export * from "./InterimDemand.component.vue?vue&type=script&lang=js"

import "./InterimDemand.component.vue?vue&type=style&index=0&id=23fc1101&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23fc1101"]])

export default __exports__